import React, { useRef, useState, useEffect } from 'react';
import './HowItWorks.scss';

const HowItWorks: React.FC = () => {
  const trackerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [lastMouse, setLastMouse] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;

      const deltaX = e.clientX - lastMouse.x;
      const deltaY = e.clientY - lastMouse.y;

      setRotation(prev => ({
        x: Math.max(-90, Math.min(90, prev.x - deltaY * 0.2)),
        y: prev.y + deltaX * 0.2
      }));

      setLastMouse({ x: e.clientX, y: e.clientY });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, lastMouse]);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setLastMouse({ x: e.clientX, y: e.clientY });
  };

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2>The Shadow Tracker Model</h2>
        <p>(Click and Drag 3D Model)</p>
        
        <div className="how-it-works-content">
          <div className="tracker-container">
            <div 
              className="tracker-3d-cube"
              onMouseDown={handleMouseDown}
              style={{
                transform: `perspective(1000px) rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
                cursor: isDragging ? 'grabbing' : 'grab'
              }}
            >
              <div className="cube-face front">
                <img 
                  src="/IoTLink-Shadow.webp" 
                  alt="Shadow Tracker Device Front" 
                  className="tracker-image"
                  draggable={false}
                />
              </div>
              <div className="cube-face back">
                <img 
                  src="/IoTLink-Shadow.webp" 
                  alt="Shadow Tracker Device Back" 
                  className="tracker-image flipped"
                  draggable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
